import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Tr = ({
	className = "",
	isBorderNone = false,
	isActive = false,
	children,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	...props
}) => {
	const borderProp = isBorderNone ? { border: { width: 0 } } : {};
	return (
		<tr
			className={classes(
				"table__tr",
				isActive && "table-active",
				...utilityClassName(deepMergeProps({ ...borderProp }, pureProps(utility))),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		>
			{children}
		</tr>
	);
};

Tr.propTypes = {
	isActive: bool,
	isBorderNone: bool,
	className: string,
	children: node.isRequired,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
};

export default Tr;
